import React from "react";
import routes from "src/core/common/routes";
import DeliveryTypeModal from "src/core/deliveries/components/DeliveryTypeModal";
import StoreSelectionModal from "src/core/deliveries/components/StoreSelectionModal";
import DeliveryModal from "src/core/deliveries/components/DeliveryModal";
import useRouter from "src/core/common/hooks/useRouter";
import Route from "src/core/common/components/modules/Route";

function DeliveryPage({onRequestClose}) {
  return (
    <>
      <Route
        path={routes.deliveryType}
        Component={DeliveryTypeModal}
        componentProps={{
          onRequestClose: onRequestClose,
        }}
      />
      <Route
        path={routes.storeSelection}
        Component={StoreSelectionModal}
        componentProps={{
          closeModal: onRequestClose,
          backToDeliveryType: true,
        }}
      />
      <Route
        path={routes.deliveryCheck}
        Component={DeliveryModalWrapper}
        componentProps={{
          onRequestClose: onRequestClose,
        }}
      />
    </>
  );
}

function DeliveryModalWrapper({onRequestClose, ...props}) {
  const router = useRouter();
  const {from} = router.query;
  function onSuccessDeliveryCheck(/*address*/) {
    if (from) {
      router.push(from);
    } else {
      onRequestClose();
    }
  }

  return (
    <DeliveryModal
      {...props}
      backToDeliveryType={true}
      closeModal={onRequestClose}
      onSuccess={onSuccessDeliveryCheck}
    />
  );
}

export default DeliveryPage;
